import WorksheetForm from '~/features/projectWizard/worksheets/common/components/WorksheetForm';
import { WorksheetField } from '~/features/projectWizard/worksheets/common/components/Field';
import { RecOwnershipRadioOptions } from '~/constants';
import { useProjectContext } from '~/hooks';
import { useDerivedRECFields } from '~/features/projectWizard/derived';
import StateSpecificRECForm from './StateSpecificRECForm';
import './styles.scss';
import RecValueAssumptions from './RecValueAssumptions';

export default function RenewableEnergyCredits () {
  const { project } = useProjectContext();

  // Update REC data based on field changes
  useDerivedRECFields();

  return (
    <div className="rec-container">
      <WorksheetForm>
        <WorksheetField
          type="radio"
          fieldLabel="Renewable energy certificates ownership"
          schemaKey="recOwnership"
          values={RecOwnershipRadioOptions}
        />
        <RecValueAssumptions project={project} />
        <StateSpecificRECForm />
        <WorksheetField
          type="textarea"
          fieldLabel='REC details'
          schemaKey="recDetails"
          placeholder="If needed, please describe any REC nuances that may be pertinent to pricing."
          optional
          fieldStyle={{ marginTop: project.addressState === 'Illinois' ? 'var(--x-large)' : undefined }}
        />
      </WorksheetForm>
    </div>
  );
}

